import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

import { ApiListResponse, AssetTaxLot } from '@types'

import api from '@/store/api'

import { prepareResponseError } from '../utils/helpers'

import { useRepositoriesStore } from '@/store/repositories/index'

export const useAssetTaxLotsStore = defineStore('asset-tax-lots', () => {
  // INIT
  const repositoriesStore = useRepositoriesStore()

  const loading = ref(false)

  let abortController = new AbortController()

  const repositoryId = computed(() => repositoriesStore.getCurrentId)

  // ACTIONS
  const fetch = async (assetId: string) => {
    if (!repositoryId.value) return []

    loading.value = true
    try {
      const result = await api.get<ApiListResponse<AssetTaxLot[]>>(
        'tax_lots',
        {
          params: {
            repository_id: repositoryId.value,
            asset_id: assetId,
          },
          signal: abortController.signal,
        },
      )
      return result.data.data
    } catch (e) {
      throw Error(prepareResponseError(e))
    } finally {
      loading.value = false
    }
  }

  const cancel = () => {
    abortController.abort()
    abortController = new AbortController()
  }

  const clear = () => {
    loading.value = false
  }

  return {
    loading,

    fetch,
    cancel,
    clear,
  }
})
